export const SET_LAB = 'SET_LAB';

export const setLab = (data) => ({
  type: SET_LAB,
  payload: data,
});